import { LoginContext, LoginContextType } from '@/hooks/useLogin';
import { useContext } from 'react';

function withLoginContext<P>(WrappedComponent: React.ComponentType<P & { loginContext: LoginContextType }>) {
  const WithLoginContext = (props: P) => {
    return <WrappedComponent {...props} loginContext={useContext(LoginContext)} />;
  };
  return WithLoginContext;
}

export default withLoginContext;
